import {
  CosmosButton,
  CosmosButtonProps,
  CosmosIconClose,
} from "@cosmos/web-react";
import classnames from "classnames/bind";
import Link from "next/link";
import React from "react";
import styles from "./FilterButtonDeselect.module.css";

const cx = classnames.bind(styles);

export const FilterButtonDeselect = ({
  children,
  href,
  shape = "pill",
  className,
  disabled,
  onClick,
}: {
  children: React.ReactNode;
  href: string;
  shape?: "pill" | "rectangle";
  className?: string;
  disabled?: boolean;
  onClick?: CosmosButtonProps["onClick"];
}) => {
  return (
    <Link passHref legacyBehavior href={href}>
      <CosmosButton
        className={cx("button", className)}
        size="small"
        kind="bare"
        appearance="dark"
        shape={shape}
        iconPlacement="after"
        disabled={disabled}
        onClick={onClick}
      >
        {children}
        <CosmosIconClose slot="icon" className={cx("icon")} />
      </CosmosButton>
    </Link>
  );
};
